class PropertyValue {
  constructor(id, value, reference, empty = undefined) {
    this.id = id;
    this._value = value;
    this._reference = reference;
    this._empty = this.__validateEmptiness(empty);
  }

  get reference() {
    return this._reference;
  }

  get value() {
    return parseInt(this._value);
  }

  set empty(boolean) {
    this._empty = this.__validateEmptiness(boolean);
  }

  get empty() {
    return this._empty;
  }

  hasReference() {
    return this.value && this._reference && this.value == this._reference;
  }

  hasRawValue() {
    return !this.isValueAbsent() && !this.hasReference();
  }

  isValueAbsent() {
    return isNaN(parseInt(this.value));
  }

  __validateEmptiness(emptiness) {
    if (this.hasRawValue() && emptiness !== false) {
      return false;
    }
    return emptiness;
  }
}

module.exports = PropertyValue;
